import { createApp } from "vue";
import "@/assets/styles/element-plus/index.scss";
import ElementPlus from "element-plus";
import "@/assets/styles/global/index.scss";
import locale from "element-plus/es/locale/lang/zh-cn";
import "element-plus-admin/utils/polyfills";
import { config } from "@/utils/config";
import { useComponents } from "@/utils/use-components";
import App from "./App.vue";
import { store } from "./store";
import { router } from "./router";
import * as buffer from "buffer";

const app = createApp(App);

if (typeof window.global === "undefined") {
  window.global = window;
}

if (typeof window.Buffer === "undefined") {
  window.Buffer = buffer.Buffer;
}

app
  .use(store)
  .use(router)
  .use(ElementPlus, { size: "medium", locale })
  .mount("#app");

config(app);
useComponents(app);
